import type { CartItemType } from '@/store/types/cart'
import { getTerms } from '@/lib/hooks/services/useGetTerms'
import type { CustomerType } from '@/store/types/user'
import { mixpanelService } from '../initializeMixPanel'
import { MixpanelEvent } from '../mixpanelEvent'
import { generateAddToCartEventData } from '../helpers/generateCartEventData'

type TrackAddToCartParams = {
  cartItem: CartItemType
  eventLocation: string
  itemCount: number
  customerType: CustomerType
  currencyCode: string
}

export const TrackAddToCart = ({
  cartItem,
  eventLocation,
  itemCount,
  customerType,
  currencyCode,
}: TrackAddToCartParams) =>
  mixpanelService.trackEvent(MixpanelEvent.ADD_TO_CART, {
    event_location: eventLocation,
    cart: generateAddToCartEventData({
      cartItem,
      currency: currencyCode || 'USD',
      price:
        getTerms({
          forCustomerType: customerType,
          pricingData: cartItem.product.pricing,
        })?.priceEach || 0,
      quantity: itemCount,
      addToCartLocation: eventLocation,
      focus: false,
    }),
    item_count: itemCount,
  })
